import React, { useEffect, useState } from 'react'
import { notify, toastStyle } from './UsersPage'
import axios from 'axios'
import { Col, Container, Row, ToastContainer } from 'react-bootstrap';
import { Button,Card,Form, Input,InputNumber,Modal,Skeleton, Spin, Switch} from 'antd';
import { API_SOCKET, AUTH_URL} from '../constants';
import { BankOutlined, BoxPlotTwoTone, CloseOutlined, DeleteOutlined, EditOutlined, SaveOutlined, SettingOutlined } from '@ant-design/icons';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { notify_success } from './LoginPage';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../features/auth/authSlice';
import { IoMdArrowDropright } from 'react-icons/io';
import withAuth from '../components/authHOC';
const { Meta } = Card;

interface IBranch {
    _id: string| undefined,
    name: string|undefined,
    location: string|undefined,
    currency: string|undefined,
    account_opening_fee: number|string | undefined,
    allow_notifications?: boolean

}


const BranchesPage = () => {
    const [domainsLoaded, setDomainsLoaded] = useState(false);
    const [branchesData, setbranchesData] = useState<IBranch[]>();
    const [branchData, setbranchData] = useState<IBranch>({
        _id: '',
        name: undefined,
        location: undefined,
        currency: undefined,
        account_opening_fee: undefined,
        allow_notifications: false
    })
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [reloadComponent, setReloadComponent] = useState(false);
    const [showNewPlantForm, setShowNewPlantForm] = useState(false) 
    const [newPlantName, setNewPlantName] = useState<string | undefined>()
    const [newPlantLocation, setNewPlantLocation] = useState<string | undefined>()
    const [newPlantAccountOpeningFee, setNewPlantAccountOpeningFee] = useState<number | string | undefined>()
    const [newPlantCurrency, setNewPlantCurrency] = useState<string | undefined>()

    const [newPlantIMEI, setNewPlantIMEI] = useState<string | undefined>()
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default')
    const [editMode, setEditMode] = useState<boolean>(false)
    const [addingBranch, setAddingBranch] = useState(false)
    const [editingBranch, setEditingBranch] = useState(false)


    const [form] = Form.useForm()


     const user_details = useSelector(selectUserDetails)
     const user_branch = user_details?.branch


    const isAdmin = user_details && user_details?.role === 'admin'



    const showModal = () => {
    setOpen(true);
     };

    const showPlantForm = ()=>{
        setShowNewPlantForm(true)
    }

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
        }, 2000);
    };

    const clearPlantForm =()=>{
        setNewPlantIMEI(undefined)
        setNewPlantLocation(undefined)
        setNewPlantName(undefined)
    }

     const handleAddPlant = async () => {
        setConfirmLoading(true)
        setAddingBranch(true)
        const response = await axios.post(`${AUTH_URL}/branches`, {name: newPlantName, location: newPlantLocation, currency: newPlantCurrency, account_opening_fee: newPlantAccountOpeningFee}, {withCredentials: true})
        setAddingBranch(false)

        clearPlantForm()
        if(response.data.success){
            notify_success(`${response.data.message}`, toastStyle)
            setShowNewPlantForm(false)
            setReloadComponent(true)
            handleCancel()
            form.resetFields()
            
        }else{
            notify(`${response.data.message}`, toastStyle)
        }
     }

    const handleCancel = () => {
        setOpen(false)
        setEditMode(false)
    };

    const handleCancelPlantForm = () => {
        setShowNewPlantForm(false)
        setEditMode(false)
    };
     

  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };
    //Get Plants
    const getBranches = async()=>{
        try {
            const plants = await axios.get(`${AUTH_URL}/branches`, {withCredentials: true})
            if(plants.data.success){
                setDomainsLoaded(true)
                setbranchesData(plants.data.branches)
              
            }else{
                setDomainsLoaded(false)

             
                notify(plants.data.message, toastStyle,)

            }

        } catch (error: any) {  
             notify(error.message, toastStyle,)
           
        }
    }

    const getPlant = async (plant_id: string | undefined)=>{
        const plant = await axios.get(`${AUTH_URL}/branches/${plant_id}`)
        if(plant.data.success){
            setbranchData(plant.data.data.data)
            showModal()
            }

    }

    const saveConfigs = async()=>{
        setEditingBranch(true)
        const response = await axios.patch(`${AUTH_URL}/branches/${branchData?._id}`, branchData, {withCredentials: true})
        setEditingBranch(false)
        setReloadComponent(true)
        handleCancel()
        if(response.data.success){
            notify_success('Branch details updated successfully', toastStyle)
        }else{
            notify(`${response.data.message}`, toastStyle)
        }
    }

    const handleNotificationToggle = async (checked: boolean) => {
        try {
            const response = await axios.post(
                `${AUTH_URL}/toggle-notifications/branches/${branchData._id}`, 
                { allow_notifications: checked },
                { withCredentials: true }
            );
            console.log(response)
            if(response.data.success) {
                setbranchData((prev) => ({
                    ...prev,
                    allow_notifications: checked
                }));
                notify_success(
                    `Notifications ${checked ? 'enabled' : 'disabled'} successfully`, 
                    toastStyle
                );
                setReloadComponent(true);
            } else {
                notify(response.data.message, toastStyle);
            }
        } catch (error: any) {
            notify(error.message, toastStyle);
        }
    };

    useEffect(()=>{
        if(reloadComponent){
            getBranches()
            setReloadComponent(false)
        }
    }, [reloadComponent])

    useEffect(()=>{
        getBranches()

    }, [])

  return (
       <Container fluid id='users-container'>
       <Row>
       <Col>
        <h4 className='text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Branches</h4>

       </Col>
       <Col className='d-flex justify-content-end'>
       {
        isAdmin 
         &&
       <Button onClick={showPlantForm} className='text-uppercase small text-end rounded-0'>Add Branch</Button>
       }
       </Col>
       </Row>
        <Row className='py-0 g-0'>
            <ToastContainer position="top-center" className='text-capitalize'/>
            {
                (domainsLoaded && branchesData) ? 
                <>
                    
                    {branchesData.map((plant:IBranch)=>{
                    return <Card
                                style={{ width: 300, marginTop: 16 }}
                                actions={[
                                <EditOutlined key="edit" />,
                                <SettingOutlined key="setting" onClick={()=> getPlant(plant._id)}/>,
                                ]}
                                className='mx-1 rounded-0'
                                >
                                <Skeleton loading={!domainsLoaded} avatar active>
                                <Meta
                                    avatar={<BankOutlined />}
                                    title={plant.name}
                                    description={plant.location}
                                />
                                </Skeleton>
                            </Card>
                    })}
                </>
                :
                 <Spin style={{paddingTop: 100}} tip="Loading branches..." size="large">
                    <div className="content" />
                </Spin>
            }
        </Row>
        <Row>
        {branchData && 
         <Modal
                title={`${branchData.name} Details`}
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                centered={true}
                width={600}
                footer={[
                    
                    editMode &&
                    [
                    <Button loading={editingBranch} onClick={saveConfigs} className='small rounded-0 text-uppercase' key="save-changes" type="primary" >
                    <span><SaveOutlined /></span>
                       { editingBranch ?
                       
                       'Saving Changes...':
                       'Save Changes'

                       }
                    </Button>,
                    <Button className='small rounded-0 text-uppercase' key="cancel" onClick={()=>setEditMode(false)}>
                     <CloseOutlined />   Cancel editing
                    </Button>
                    
                    ],
                    !editMode && 
                    [
                        <Button type='primary' className='small rounded-0 align-items-center' key="edit" onClick={()=> setEditMode(true)}>
                        <span><EditOutlined /></span> Edit
                        </Button>,
                        <Button className='small rounded-0' key="cancel" onClick={handleCancel}>
                        <CloseOutlined />   Cancel
                        </Button>,
                    ]
        
                ]}
            >
            <Row>
            <Card>
                <Form
                    layout="vertical"
                    initialValues={{ size: componentSize }}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                    style={{ maxWidth: 600 }}
                    >
                    <Form.Item label="Branch Name">
                        <Input value={branchData.name} disabled={!editMode} 
                            onChange={(e) =>
                                    setbranchData((prevbranchData: IBranch) => ({
                                        ...prevbranchData,
                                        name: e.target.value,
                                    }))
                                }
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Location"
                    >
                        <Input value={branchData.location} disabled={!editMode} 
                        onChange={(e) =>
                                setbranchData((prevbranchData: IBranch) => ({
                                    ...prevbranchData,
                                    location: e.target.value,
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Currency"
                    >
                        <Input value={branchData.currency} disabled={!editMode} 
                        onChange={(e) =>
                                setbranchData((prevbranchData: IBranch) => ({
                                    ...prevbranchData,
                                    currency: e.target.value,
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Account opening fee"
                    >
                        <Input value={branchData.account_opening_fee} disabled={!editMode} 
                        onChange={(e) =>
                                setbranchData((prevbranchData: IBranch) => ({
                                    ...prevbranchData,
                                    account_opening_fee: e.target.value,
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item 
                        label="Allow Notifications"
                        tooltip="Enable or disable SMS notifications for this branch"
                    >
                        <div className="d-flex align-items-center">
                            <Switch 
                                checked={branchData.allow_notifications} 
                                onChange={handleNotificationToggle}
                                disabled={!isAdmin}
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                            />
                            <span className="ms-2 small">
                                {branchData.allow_notifications ? 'Notifications Enabled' : 'Notifications Disabled'}
                            </span>
                        </div>
                    </Form.Item>
                </Form>
            </Card>
            </Row>
            </Modal>
        
        }
           
        </Row>
         <Row>
        {showNewPlantForm && 
         <Modal
                title={`Add New Branch`}
                open={showNewPlantForm}
                onOk={handleAddPlant}
                confirmLoading={confirmLoading}
                onCancel={handleCancelPlantForm}
                centered={true}
                className='rounded-0'
                footer={[
                     [

                      ]
                ]}
            >
            <Row>
            <Card className='rounded-0'>
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleAddPlant}
                    >
                    <Form.Item 
                    label="Branch Name"
                    name="branch_name"
                    rules={[{ required: true, message: "Branch name is required" }]}
                    >
                        <Input value={newPlantName} onChange={(e)=> setNewPlantName(e.target.value)} />
                    </Form.Item>
                    <Form.Item 
                        label="Location"
                        name="branch_location"
                        rules={[{ required: true, message: "Branch location is required" }]}
                        >
                        <Input value={newPlantLocation} onChange={(e)=>setNewPlantLocation(e.target.value)} />
                    </Form.Item>
                    <Form.Item 
                        label="Currency"
                        name="currency"
                        rules={[{ required: true, message: "Operational currency is required" }]}
                        tooltip="E.g RWF for Rwandan Francs, UGX for Ugandan Shillings, USD for US Dollar"
                        >
                        <Input value={newPlantCurrency} onChange={(e)=>setNewPlantCurrency(e.target.value)} />
                    </Form.Item>
                    <Form.Item 
                        label="Account opening fee"
                        name="account_opening_fee"
                        rules={[{ required: true, message: "Account opening fee is required" }]}
                        tooltip="Write 0 if account opening is free"
                        >
                        <Input value={newPlantAccountOpeningFee} onChange={(e)=>setNewPlantAccountOpeningFee(e.target.value)} />
                    </Form.Item>
                    <Row>
                    <Col className='d-flex'>
                    <Button 
                        htmlType='submit' 
                        loading={addingBranch}
                        className='text-uppercase rounded-0'
                        type='primary'
                        >
                      {
                        addingBranch ?
                        'Adding branch...':
                        'Add Branch'
                      }
                    </Button>
                    <Button className='small rounded-0 mx-2' key="cancel" onClick={handleCancelPlantForm}>
                        <CloseOutlined />   Cancel
                        </Button>
                    
                    </Col>
                    </Row>
                    
                </Form>
            </Card>
                

            
            </Row>
            </Modal>
        
        }
           
        </Row>
      

    </Container>
  )

}

export default withAuth ( BranchesPage,  ['admin'])
